/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class MemberApplyMaterials extends Mb {
    constructor() {
        super();
        this.baseUrl += '/memberApplyMaterials';
    }

    data({
        certCatId,
        applyMaterialsName,
        applyMaterialsType,
        expireStatus,
        userName,
        fullName,
        mobile,
        expireTime,
        reviewTime,
        currentPage,
        pageSize,
    } = {}) {
        let expireBeginTime = null;
        let expireEndTime = null;
        if (expireTime != null && expireTime.length === 2) {
            [expireBeginTime, expireEndTime] = expireTime;
        }
        let reviewTimeBegin = null;
        let reviewTimeEnd = null;
        if (reviewTime != null && reviewTime.length === 2) {
            [reviewTimeBegin, reviewTimeEnd] = reviewTime;
        }
        return super.get('/data', {
            certCatId,
            applyMaterialsName,
            applyMaterialsType,
            expireStatus,
            userName,
            fullName,
            mobile,
            expireTime,
            expireBeginTime,
            expireEndTime,
            reviewTimeBegin,
            reviewTimeEnd,
            currentPage,
            pageSize,
        });
    }

    findMemberApplyMaterialsList({ memberId } = {}) {
        return super.get('/findMemberApplyMaterialsList', {
            memberId,
        });
    }

    getMemberApplyMaterialsDetail({ id }) {
        return super.get('/getMemberApplyMaterialsDetail', { id });
    }

    saveApplyMaterials({ id, applyMaterialsValue }) {
        return super.post('/saveApplyMaterials', { id, applyMaterialsValue });
    }

    save({ id, certCatId } = {}) {
        return super.post('/save', { id, certCatId });
    }

    getDetail({ id }) {
        return super.get('/getMemberApplyMaterialsDetail', { id });
    }
}

export default new MemberApplyMaterials();
export { MemberApplyMaterials };
